<template>
  <div>
     <el-table
       :data="tableData"
       style="width: 100%"
    @selection-change="selectedRows">
        <el-table-column
          align="center"
          prop="ssl_issuer"
          :label="$t('certManage.certSource')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_type"
          :label="$t('certManage.type')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_state"
          :label="$t('certManage.certStatus')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="auto_ssl"
          :label="$t('certManage.autoRenew')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="ssl_expired"
          :label="$t('certManage.dueDate')"
        >
        </el-table-column>
     </el-table>
        
      <div class="pagination-bottom">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>

  </div>
</template>

<script>
/* eslint-disable */
import { certList } from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
    };
  },
  computed: {
    headerLables() {
      return [
        // { label: this.$t("allDomain.domain"), value: "host" },
        { label: this.$t("certManage.certSource"), value: "ssl_issuer" },
        { label: this.$t("certManage.type"), value: "ssl_type" },
        { label: this.$t("certManage.certStatus"), value: "ssl_state" },
        { label: `${this.$t("certManage.autoRenew")}`, value: "auto_ssl" },
        { label: `${this.$t("certManage.dueDate")}`, value: "ssl_expired" },
      ];
    },
  },
  mounted() {
    this.getCertList({ page: 1 });
  },
  methods: {
    getCertList({
      page,
      host,
      start_date,
      end_date,
      ssl_type,
      auto_ssl,
      ssl_state,
    }) {
      certList({
        page,
        limit: this.pageSize,
        start_date,
        end_date,
        host: this.domainHost,
        ssl_type,
        auto_ssl,
        ssl_state,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.tableData = list.data;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    handleChange(e) {
      console.log("pagination", e);
    },
    selectedRows(items) {
      console.log(items);
      this.selectItems = items;
    },
    add() {
      console.log("add");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
